import { Controller } from "@hotwired/stimulus"

// AnalyticsController fires checkout_abandoned to /analytics/event when the
// user closes the tab or navigates away mid-checkout. The other 7 shared
// checkout events fire server-side; this controller exists solely for the
// abandonment beacon, so the controller stays small on purpose.
export default class extends Controller {
  endpoint = "/analytics/event"

  connect() {
    this.viewport = this.resolveViewport()
    this.boundUnload = this.handleBeforeUnload.bind(this)
    window.addEventListener("beforeunload", this.boundUnload)
    this.connectedAt = Date.now()
  }

  disconnect() {
    if (this.boundUnload) {
      window.removeEventListener("beforeunload", this.boundUnload)
    }
  }

  resolveViewport() {
    const fromAttr = this.element?.dataset?.analyticsViewport
    if (fromAttr) return fromAttr
    if (typeof window === "undefined") return ""
    const w = window.innerWidth || 0
    if (w >= 1280) return "desktop"
    if (w >= 768) return "tablet"
    return "mobile"
  }

  handleBeforeUnload() {
    const lastStep = this.element?.dataset?.analyticsLastStep || ""
    const session = this.element?.dataset?.analyticsSession || ""
    const checkoutSessionId = this.element?.dataset?.analyticsCustomidCheckoutSessionId || ""
    const partnerId = this.element?.dataset?.analyticsCustomidPartnerId || ""
    const timeSpent = String(Date.now() - (this.connectedAt || Date.now()))

    const formData = new FormData()
    formData.append("event", "checkout_abandoned")
    formData.append("page", window.location.pathname)
    formData.append("ts", String(Date.now()))
    formData.append("viewport", this.viewport)
    if (session) formData.append("session", session)
    if (lastStep) formData.append("last_step", lastStep)
    formData.append("time_spent_ms", timeSpent)
    // Sent as a fallback for the rare case where the server-side session
    // load fails (cookie cleared, DB blip). When it succeeds, the backend
    // recovers these from sess.Data and ignores these fields.
    if (checkoutSessionId) formData.append("checkout_session_id", checkoutSessionId)
    if (partnerId) formData.append("partner_id", partnerId)

    if (navigator.sendBeacon) {
      const ok = navigator.sendBeacon(this.endpoint, formData)
      if (ok) return
    }
    fetch(this.endpoint, { method: "POST", body: formData, keepalive: true }).catch(() => { })
  }
}
